import { RepayRequest } from './RepayRequest';
import { OngoingPaymentPlan } from '../../Dashboard.types';
import OrderSummary from '../OrderSummary/OrderSummary';

export const OverdueView = ({
  paymentPlan,
}: {
  paymentPlan: OngoingPaymentPlan;
}) => {
  return (
    <div className="flex flex-col gap-l">
      <div className="flex flex-col gap-l">
        <div>
          <RepayRequest paymentPlan={paymentPlan} />
        </div>
        <OrderSummary paymentPlan={paymentPlan} />
      </div>
    </div>
  );
};
